// extracted by mini-css-extract-plugin
export var icon = "_bp-3";
export var subtitle = "_bp-2";
export var title = "_bp-1";
export var value = "_bp-0";